// API Configuration
// This file centralizes all API endpoints and configuration

// Main Snwolley API - Use local API for development
function apiBase(envValue) {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host !== 'localhost' && host !== '127.0.0.1') {
      return `${window.location.origin}/api/v1`;
    }
  }
  return envValue || 'http://127.0.0.1:51926/api/v1';
}

export const MAIN_API_BASE_URL = apiBase(process.env.REACT_APP_API_BASE_URL);
export const VERSION_CONTROL_API_URL = apiBase(
  process.env.REACT_APP_VERSION_CONTROL_API_URL
);

// Environment
export const NODE_ENV = process.env.NODE_ENV || 'development';

// API configuration ready
